
import React from 'react'
// import { NavLink } from 'react-router-dom'
import { swiperList } from '@/constants'
import defaultSetting from '@/setting'

function SwiperItem () {
    return (
        swiperList.map((item, index) => {
            return (
                <div className="swiper-slide lx-w100 lx-h100 lx-hidden" key={index} >
                    {/* <img className="lx-image-rendering banner-img" src={item.imgUrl} alt="banner" /> */}
                    <a
                        className="banner-img lx-h100 lx-fz0"
                        style={{backgroundImage: `url('${item.imgUrl}')`}}
                        href={`/${defaultSetting.suiteKey}/pb/school.html`}
                        rel="noreferrer"
                    >

                    </a>
                </div>
            )
        })
    ) 
}


export default SwiperItem;